module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Loading-4025174ca37b1b608bc61c479e9ebae8.svg";